import {FC} from 'react'
import {Link} from 'react-router-dom'
import {AuthModel} from '../../modules/auth/core/_models'
import {ONLINE_REGISTRATION_PATH} from '../../modules/auth/core/onlineRegistration'
import {isSsoSession} from '../../modules/auth/core/ssoBusinessRegistration'

type Props = {
  user?: AuthModel
}

// The dashboard notice the old ASA front end showed after a tax-folder SSO login: which identity the session came
// from. A session without a business never reaches the dashboard (BusinessRequired).
const SsoDashboardNotices: FC<Props> = ({user}) => {
  if (!isSsoSession(user)) return null

  return (
    <section className='mp-sso-notice mp-sso-notice--info' aria-label='ورود با کارپوشه'>
      <i className='las la-landmark' aria-hidden='true' />
      <div>
        <strong>
          شما با کارپوشه مالیاتی و کد ملی/شناسه ملی{' '}
          <span dir='ltr' className='mp-sso-notice__nid'>
            {user?.sso?.nid}
          </span>{' '}
          وارد شده‌اید.
        </strong>
        <Link to={ONLINE_REGISTRATION_PATH}>افزودن کسب‌وکار دیگر</Link>
      </div>
    </section>
  )
}

export {SsoDashboardNotices}
